import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    box-sizing: border-box;
    font-family: 'Noto Sans', 'sans-serif';
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

export default GlobalStyle;
